var map = {
	"./About.vue": [
		5896,
		896
	],
	"./Datenschutz.vue": [
		6427,
		427
	],
	"./Home.vue": [
		1152,
		152
	],
	"./Impressum.vue": [
		3083,
		83
	],
	"./Infothek.vue": [
		8240,
		240
	],
	"./Infothek_old.vue": [
		7511,
		511
	],
	"./Kontakt.vue": [
		7209,
		209
	],
	"./Lerneinheiten.vue": [
		5335,
		335
	],
	"./Material.vue": [
		6717,
		717
	],
	"./MemoryDetail.vue": [
		1429,
		429
	],
	"./MemoryOverview.vue": [
		3502,
		502
	],
	"./MethodDetail.vue": [
		145,
		145
	],
	"./MethodPdfDownload.vue": [
		3124,
		124
	],
	"./MethodSubmit.vue": [
		6158,
		158
	],
	"./Methods.vue": [
		8929,
		929
	],
	"./News.vue": [
		9184,
		184
	],
	"./NewsDetail.vue": [
		6415,
		415
	],
	"./Page.vue": [
		1127,
		127
	],
	"./PugTest.vue": [
		9429,
		13
	],
	"./ShoppingCart.vue": [
		7648,
		648
	],
	"./Team.vue": [
		5311,
		311
	],
	"./WorkshopDetail.vue": [
		6590,
		109
	],
	"./WorkshopOverview.vue": [
		3291,
		291
	],
	"./WorkshopRequest.vue": [
		6603,
		603
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;